import { API_STATES } from "@/helpers";

const state = {
  tasksGetState            : API_STATES.NOT_REQUESTED,
  tasksGetError            : null,
  taskDeleteState          : API_STATES.NOT_REQUESTED,
  tasksDeleteError         : null,
  taskCreateState          : API_STATES.NOT_REQUESTED,
  taskCreateError          : null,
  taskUpdateState          : API_STATES.NOT_REQUESTED,
  taskUpdateError          : null,
  taskPositionUpdating     : [],
  taskPositionUpdateError  : null,
  taskPositionDeleting     : [],
  taskPositionDeleteError  : null,
  taskPositions            : [],
  taskExemptionUpdating    : [],
  taskExemptionUpdateError : null,
  taskExemptionDeleting    : [],
  taskExemptionDeleteError : null,
  taskExemptions           : [],
  taskSkillUpdating        : [],
  taskSkillUpdateError     : null,
  taskSkillDeleting        : [],
  taskSkillDeleteError     : null,
  taskSkills               : [],
  tasks                    : [],
  task                     : {}
};

export default state;